import { createFileRoute } from '@tanstack/react-router'
import AdminOrganizationsPage from '@/components/pages/Admin/AdminOrganizationsPage/AdminOrganizationsPage'
import { z } from 'zod'

const searchSchema = z.object({
  page: z.number().optional(),
  query: z.string().optional(),
  sort_by: z.string().optional(),
  sort_order: z.string().optional(),
})

export const Route = createFileRoute('/$workspaceName/$environment/admin/organizations/')({
  validateSearch: (search) => searchSchema.parse(search),
  component: AdminOrganizationsRoute,
})

function AdminOrganizationsRoute() {
  return <AdminOrganizationsPage />
}
